export const PhoneSearchFormFields = {
  phoneNumber: 'phoneNumber',
} as const;
